export class FilterListFieldEntry {
  constructor(public id: string, public displayValue: string) {
  }
}
